export default __webpack_public_path__ + "static/media/nss-3.ad96dad4.png";